import {ORGANIZE_MODULE} from "@common/model/constants";
import angular from "angular";

export class OrganizePageController {
      redirectTo: string;
      displayFor: string;

      static $inject = ["$state"];
      constructor(private $state : angular.ui.IStateService) {
          this.displayFor = ORGANIZE_MODULE;
          if (!!this.$state.params.ref) {
              this.redirectTo = this.$state.params.ref;
          }
      }
    }

angular.module('eCareVault.common.uploadDocuments')
    .controller('OrganizePageController', OrganizePageController);
